export function camelCase(str: string = ''): string {
    // Split the string at all space characters
    const camelCasedStr = str
        // add _ character before every capital letter which previous character isn't capital letter
        .replace(/([^A-Z])([A-Z])/g, '$1_$2')
        // replace non word characters and _ character with one _ character
        .replace(/[\W_]+/g, '_')
        // split string by _ character
        .split(/[_]+/)
        // get rid of any empty strings
        .filter((a) => a !== '')
        // Convert first char to upper case for each word
        .map((a) => a[0].toUpperCase() + a.substring(1).toLowerCase())
        // Join all the strings back together
        .join('');

    if (camelCasedStr.length === 0) {
        return camelCasedStr;
    }

    // first letter should be in lower case
    return camelCasedStr[0].toLowerCase() + camelCasedStr.substring(1);
}
